import { Component, OnInit } from '@angular/core';
import { Service } from './models/Service.model';
import { BookingService } from '../booking/booking.service';

@Component({
    selector: 'app-service',
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.scss'],
    standalone: false
})
export class ServiceComponent implements OnInit {

  hairServices: Service[] = [];
  hairExtras: Service[] = [];
  lashServices: Service[] = [];
  nailServices: Service[] = [];
  otherServices: Service[] = [];

  constructor(public booking: BookingService) { }

  ngOnInit(): void {
    this.buildServices();
  }

  buildServices(): void {
    this.hairServices = [
      {
        name: 'Women\'s Cut',
        price: 30,
        priceText: '. . .$30+'
      },
      {
        name: 'Men\'s Cut',
        price: 25,
        priceText: '. . .$25+'
      },
      {
        name: 'Kids Cut',
        price: 20,
        priceText: '. . .$20'
      },
      {
        name: 'All Over Color',
        price: 120,
        priceText: '. . .$120+'
      },
      {
        name: 'Root Touch-up',
        price: 75,
        priceText: '. . .$75+'
      },
      {
        name: 'Color Correction',
        price: 200,
        priceText: '. . .$200+'
      },
      {
        name: 'Toner Refresh',
        price: 45,
        priceText: '. . .$45'
      },
      {
        name: 'Full Highlight',
        price: 130,
        priceText: '. . .$130+'
      },
      {
        name: 'Balayage',
        price: 130,
        priceText: '. . .$130+'
      },
      {
        name: 'Hair Extensions',
        price: 0,
        priceText: 'Consultation'
      },
      {
        name: 'Extensions Touch-up',
        price: 50,
        priceText: '. . .$50+'
      },
      {
        name: 'Extensions Removal',
        price: 50,
        priceText: '. . .$50+'
      },
    ];

    this.hairExtras = [
      {
        name: 'Hair Treatment',
        price: 45,
        priceText: '. . .$45'
      },
      {
        name: 'Steam Infusion',
        price: 45,
        priceText: '. . .$45'
      },
      {
        name: 'Hair Mask',
        price: 20,
        priceText: '. . .$20'
      },
      {
        name: 'Pre-Art Treatment',
        price: 20,
        priceText: '. . .$20'
      },
      {
        name: 'Wash + Style',
        price: 35,
        priceText: '. . .$35'
      },
      {
        name: 'Special Occasion / Up-Do',
        price: 65,
        priceText: '. . .$65'
      },
      {
        name: 'Prom',
        price: 45,
        priceText: '. . .$45'
      }
    ];

    this.lashServices = [
      {
        name: 'Classic Full Set',
        price: 130,
        priceText: '. . .$130'
      },
      {
        name: 'Classic Fill (1 Week)',
        price: 50,
        priceText: '. . .$50'
      },
      {
        name: 'Classic Fill (2 Week)',
        price: 50,
        priceText: '. . .$50'
      },
      {
        name: 'Hybrid Full Set',
        price: 150,
        priceText: '. . .$150'
      },
      {
        name: 'Hybrid Fill (1 Week)',
        price: 60,
        priceText: '. . .$60'
      },
      {
        name: 'Hybrid Fill (2 Week)',
        price: 60,
        priceText: '. . .$60'
      },
      {
        name: 'Volume Full Set',
        price: 120,
        priceText: '. . .$120'
      },
      {
        name: 'Volume Fill (1 Week)',
        price: 50,
        priceText: '. . .$50'
      },
      {
        name: 'Volume Fill (2 Week)',
        price: 60,
        priceText: '. . .$60'
      },
      {
        name: 'Mega Volume Full Set',
        price: 130,
        priceText: '. . .$130'
      },
      {
        name: 'Mega Volume Fill (1 Week)',
        price: 60,
        priceText: '. . .$60'
      },
      {
        name: 'Mega Volume Fill (2 Week)',
        price: 70,
        priceText: '. . .$70'
      },
      {
        name: 'Lash Extension Removal',
        price: 40,
        priceText: '. . .$40'
      }
    ];

    this.nailServices = [
      {
        name: 'Tier 1 Full Set (Gel-X / Builder Gel)',
        price: 60,
        priceText: '. . .$60+'
      },
      {
        name: 'Tier 2 Full Set (Gel-X / Builder Gel)',
        price: 70,
        priceText: '. . .$70+'
      },
      {
        name: 'Tier 3 Full Set (Gel-X / Builder Gel)',
        price: 80,
        priceText: '. . .$80+'
      },
      {
        name: 'Gel Manicure',
        price: 40,
        priceText: '. . .$40+'
      },
      {
        name: 'Soak Off',
        price: 15,
        priceText: '. . .$15'
      }
    ];

    this.otherServices = [
      {
        name: 'Lash Lift & Tint',
        price: 85,
        priceText: '. . .$85'
      },
      {
        name: 'Brow Lamination & Tint',
        price: 75,
        priceText: '. . .$75'
      },
      {
        name: 'Brow Shaping Wax',
        price: 20,
        priceText: '. . .$20'
      },
      {
        name: 'Lip Wax',
        price: 10,
        priceText: '. . .$10'
      },
      {
        name: 'Chin Wax',
        price: 15,
        priceText: '. . .$15'
      },
      {
        name: 'Facial Waxing',
        price: 15,
        priceText: '. . .$15'
      },
      {
        name: 'Microblading',
        price: 475,
        priceText: '. . .$475'
      },
      {
        name: 'Microblading Touch-Up',
        price: 150,
        priceText: '. . .$150'
      }
    ];
  }

}
